// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"not-found_wrapper__GAmb3","title":"not-found_title__ltv_A","text":"not-found_text__szj6Q"};